export default "__VITE_ASSET___8LE4XEn__"